var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSafepal = function SvgSafepal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    width: 32,
    color: "text",
    xmlns: "http://www.w3.org/2000/svg",
    className: "safepal_svg__sc-bdnxRM safepal_svg__kDWlca"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.55 41.939v8.527h-9.155v35.131l-2.387-.89a79.857 79.857 0 0 1-5.103-2.115l-1.037-.474V14.682l9.089-2.805 8.593 2.65v9.199l-8.593-2.659-.562.174V41.94h9.155ZM16 50.466V21.774l20.17-6.226v9.157L24.526 28.32v13.619H36.17V81.38l-2.579-1.327C25.566 75.924 16 68.96 16 59.234V54.65h8.526v4.584c0 2.012 1.047 4.127 3.117 6.303V50.466H16ZM59.139 15.33l20.665 6.396v28.74H67.671v12.445s-2.713 3.556-8.525 6.534L59.14 15.33Zm12.14 26.609v-13.66l-3.608-1.114v14.774h3.607Zm0 17.927V54.65h8.525v5.216c0 14.493-21.028 22.835-27.474 25.047l-2.344.81v-9.016l1.145-.433C61.16 72.5 71.278 65.963 71.278 59.866Z"
  })));
};
export default SvgSafepal;